import {Component} from 'react';
import Action from 'components/organisms/projection-boost-rule/actions';
import {RuleItem, RuleItemData} from 'components/organisms/projection-boost-rule/rule-item';
import Validator from 'components/organisms/projection-boost-rule/validators/validator';
import {showPopup} from 'helpers/modal';
import {sortByProperty} from 'helpers/sorters';
import NumberHelper from 'helpers/number-helper';
import {generateSignature} from 'helpers/hash';
import Const from 'const';
import {isKeyPlayerLineupPositionUsed} from 'components/organisms/projection-boost-rule/helpers';

function sortPlayers(players) {
    return players.sort(sortByProperty('salary', 'desc'));
}

function getPlayerOptionValue(player) {
    return player ? {value: player.playerId, label: player.name} : '';
}

function getPositionOptionValue(position) {
    return {label: position, value: position};
}

abstract class AbstractSettings extends Component {
    boostStatement: object;

    constructor(props) {
        super(props);
        this.boostStatement = {
            boostType: 'increase',
            boostFor: 'position',
            boostedPositions: [],
            boostedPlayer: '',
            isSameTeam: 1,
            boostPercent: 1,
        };
        this.state = {
            statementType: 'position',
            keyPosition: '',
            keyPlayer: '',
            keyPlayerLineupPosition: Const.FLEX_MODE,
            boostStatements: {
                [generateSignature()]: cp(this.boostStatement),
            },
        };
    }

    onAddRuleItem() {
        try {
            this.addRuleItem(new RuleItem(cp(this.state) as RuleItemData));
        } catch (e) {
            // @ts-ignore
            this.props.dispatch(showPopup(e.message));
        }
    }

    addRuleItem(ruleItem) {
        this.assertSettingsValid(ruleItem);
        // @ts-ignore
        this.props.dispatch(Action.do('addItemToProjectionBoostRule', ruleItem));
    }

    assertSettingsValid(ruleItem) {
        // @ts-ignore
        const {projectionBoostRule, sportConfig, players} = this.props;

        const validator = new Validator();
        validator.setDependencies({ruleItem, projectionBoostRule, sportConfig, players});
        if (!validator.validate()) {
            throw new Error(validator.getFirstError());
        }
    }

    onAddStatement() {
        // @ts-ignore
        const {boostStatements} = this.state;
        boostStatements[generateSignature()] = cp(this.boostStatement);

        this.setState({boostStatements});
    }

    onChangeStatementType(statementType) {
        this.setState({statementType});
    }

    onChangeKeyPlayer(selectedPlayer) {
        this.setState({keyPlayer: selectedPlayer ? selectedPlayer.value : ''});
    }

    onChangeKeyPosition(keyPosition) {
        this.setState({keyPosition});
    }

    updateBoostStatement(statementKey, propName, value) {
        // @ts-ignore
        const {boostStatements} = this.state;
        boostStatements[statementKey][propName] = value;

        this.setState({boostStatements});
    }

    onChangeBoostType(statementKey, value) {
        this.updateBoostStatement(statementKey, 'boostType', value);
    }

    onChangeBoostFor(statementKey, value) {
        this.updateBoostStatement(statementKey, 'boostFor', value);
    }

    onChangeBoostedPlayer(statementKey, selectedPlayer) {
        this.updateBoostStatement(statementKey, 'boostedPlayer', selectedPlayer ? selectedPlayer.value : '');
    }

    onChangeBoostedPositions(statementKey, value) {
        this.updateBoostStatement(statementKey, 'boostedPositions', value);
    }

    onChangeIsSameTeam(statementKey, value) {
        this.updateBoostStatement(statementKey, 'isSameTeam', value * 1);
    }

    onBlurBoostPercent(statementKey, value) {
        // @ts-ignore
        value = NumberHelper.prepareInt(value, 1).limitByRange(1, 100, 1).get();

        this.updateBoostStatement(statementKey, 'boostPercent', value * 1);
    }

    onRemoveStatement(statementKey) {
        // @ts-ignore
        const {boostStatements} = this.state;
        delete boostStatements[statementKey];

        this.setState({boostStatements});
    }

    getPositionNames() {
        // @ts-ignore
        const {sportConfig} = this.props;

        let positionNames = sportConfig
            .getFilter('positions', [])
            .filter((position) => position.key !== 'FLEX')
            .map((position) => position.key);

        if (sportConfig.isSiteDraftkings() && sportConfig.isSportNba()) {
            positionNames = positionNames.filter((positionName) => !['F', 'G'].includes(positionName));
        }

        return positionNames;
    }

    onSelectKeyPlayerLineupPosition(value) {
        this.setState({keyPlayerLineupPosition: value});
    }

    canKeyPlayerLineupPositionBeRendered() {
        // @ts-ignore
        const {sportConfig} = this.props;

        return isKeyPlayerLineupPositionUsed(sportConfig);
    }
}

export default AbstractSettings;

export {sortPlayers, getPlayerOptionValue, getPositionOptionValue};
